
import { Component, Mixins } from "vue-property-decorator";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { IItemSelectTriggerBehaviorPropertyEditable, instanceOfIItemSelectTriggerBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ItemSelectTriggerBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IItemSelectTriggerBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IItemSelectTriggerBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isItemSelectTriggerBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIItemSelectTriggerBehaviorPropertyEditable(s) && s.itemSelectTriggerBehavior().isEditable(), false);
  }

  get itemSelectTriggerBehavior(): IObjectsControllable<ILinkedPageObjectSpecifiable> {
    return this.readPropertyOrDefault(s => s.itemSelectTriggerBehavior().getValue(), { targets: [] });
  }

  set itemSelectTriggerBehavior(value: IObjectsControllable<ILinkedPageObjectSpecifiable>) {
    this.writePropertyWhenValid(s => s.itemSelectTriggerBehavior().setValue(value));
  }
}
